/** custom hooks & query & context */
import { useMutation, useQuery } from "@tanstack/react-query";
import { ProviderQueryClient } from "../providers/QueryProvider";

/** services */
import {
  addToCart,
  createOrder,
  createProduct,
  deleteCartItem,
  getAllCartItem,
  getAllOrder,
  getAllProduct,
  getOrderById,
  getProductById,
  updateOrder,
} from "../services/api";

/** constant */
import {
  QUERY_CART_KEY,
  QUERY_ORDER_KEY,
  QUERY_PRODUCT_KEY,
} from "../constants/query.constant";

/** utils */
import { handleGetUserFromLocalStorage } from "../utils/common";

/** interfaces */
import { IUser } from "../Interfaces/user";
// import { IProduct } from "../Interfaces/product";
// import { IApiResponse } from "../Interfaces/common";

const currentUser = JSON.parse(
  handleGetUserFromLocalStorage() as string
) as IUser;

export const useCartQuery = () => {
  // const Prefetch = (userId: string) => {
  //   const queryKey = [QUERY_CART_KEY, userId];
  //   return useQuery({
  //     queryKey,
  //     queryFn: async () => await getAllCartItem(userId),
  //   });
  // };

  const Prefetch = (userId: string, forceFresh?: true) => {
    const queryKey = [QUERY_CART_KEY, userId];
    return useQuery({
      queryKey,
      queryFn: async () => await getAllCartItem(userId),
      refetchOnMount: forceFresh ? "always" : false,
      staleTime: forceFresh ? 0 : 1000 * 60 * 5,
    });
  };

  const updateMutation = useMutation({
    mutationFn: addToCart,
    onSuccess: async () => {
      await ProviderQueryClient.invalidateQueries({
        queryKey: [QUERY_CART_KEY, currentUser?._id],
      });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteCartItem,
    onSuccess: async () => {
      await ProviderQueryClient.invalidateQueries({
        queryKey: [QUERY_CART_KEY, currentUser?._id],
      });
    },
  });

  return {
    Prefetch,
    updateMutation,
    deleteMutation,
  };
};

export const useProductQuery = () => {
  const Prefetch = (pageNumber?: number) => {
    const queryKey = [QUERY_PRODUCT_KEY];
    return useQuery({
      queryKey,
      queryFn: async () => await getAllProduct(pageNumber),
    });
  };

  const PrefetchById = (id: string | undefined) => {
    const queryKey = [QUERY_PRODUCT_KEY, id];
    return useQuery({
      queryKey,
      queryFn: async () => {
        if (id === undefined || id === "" || id === null) {
          return { data: undefined, message: "Id missing" };
        }
        return await getProductById(id);
      },
    });
  };

  const createMutation = useMutation({
    mutationFn: createProduct,
    onSuccess: async () => {
      await ProviderQueryClient.invalidateQueries({
        queryKey: [QUERY_PRODUCT_KEY],
      });
    },
  });

  return {
    Prefetch,
    PrefetchById,
    createMutation,
  };
};

export const useOrderQuery = () => {
  const Prefetch = () => {
    const queryKey = [QUERY_ORDER_KEY];
    return useQuery({
      queryKey,
      queryFn: async () => await getAllOrder(),
    });
  };

  const PrefetchById = (orderId: string) => {
    const queryKey = [QUERY_ORDER_KEY, orderId];
    return useQuery({
      queryKey,
      queryFn: async () => await getOrderById(orderId),
    });
  };

  const createMutation = useMutation({
    mutationFn: createOrder,
    onSuccess: async () => {
      await ProviderQueryClient.invalidateQueries({
        queryKey: [QUERY_ORDER_KEY],
      });
    },
  });

  const updateMutation = useMutation({
    mutationFn: updateOrder,
    onSuccess: async () => {
      await ProviderQueryClient.invalidateQueries({
        queryKey: [QUERY_ORDER_KEY],
      });
    },
  });

  return {
    Prefetch,
    PrefetchById,
    createMutation,
    updateMutation,
  };
};
